export default {
  type: "object",
  properties: {
    name: {
      type: "string",
      description: "license name",
      example: "ULTIMATE"
    },
    start_date: {
      type: "string-date",
      description: "start of validity",
      example: "1.1.1970"
    },
    end_date: {
      type: "string-date",
      description: "end of validity",
      example: "19.1.2038"
    },
    services: {
      $ref: "#/components/schemas/licenseServices"
    }
  }
};
